import Sidebar from "../../components/Sidebar";
import React, {useEffect, useState} from "react";
import AdminPageHeader from "../../components/Header/AdminPageHeader";
import {accountInfo} from "../../constants/constants";
import {Environment} from "../../utils/_dummyData";
import {
  ALL_CUSTOMER_MANAGEMENT_PAGE,
  ALL_STORE_LIST_MANAGEMENT_PAGE,
} from "../../constants/page_constants";
import AdminNoticeModal from "../../components/Modal/AdminNoticeModal";
import neverLandUtils from "../../utils/NeverLandUtils";
import {Link} from "react-router-dom";

const ManageSupportPage = () => {
  const [noticeModalOpen, setNoticeModalOpen] = useState(false);

  const checkShowNoticeModal = () => {
    // 확인 눌러서 로컬에 isOpen:false 일때 모달 안보이게
    if (neverLandUtils.commons.load('admin_noti_modal').isOpen === false) {
      setNoticeModalOpen(false);
    }
    return false;
  }

  useEffect(() => {
    // 로컬 스토리지에서 알림창 값 불러오기
    const getNotiToLocal = neverLandUtils.commons.load('admin_noti_modal');

    if (getNotiToLocal === null) {
      neverLandUtils.commons.save('admin_noti_modal', {isOpen: true});
      setNoticeModalOpen(true);
    } else {
      // 확인 눌러서 로컬에 isOpen:false 일때 모달 안보이게
      if (getNotiToLocal.isOpen === false) {
        setNoticeModalOpen(false);
      } else {
        checkShowNoticeModal();
      }
    }
  }, []);

  return (
      <div>
        {noticeModalOpen && <AdminNoticeModal setNoticeModalOpen={setNoticeModalOpen}/>}

        <Sidebar/>

        <main className="lg:pl-64 min-h-screen">
          <AdminPageHeader/>

          {Environment.isTest && accountInfo.isAdmin() &&
              <div className="min-h-screen pt-32 pl-14 flex flex-col">
                <div className="flex flex-col justify-start">
                  <Link to={ALL_CUSTOMER_MANAGEMENT_PAGE}
                        className="w-48 gap-x-3 rounded-md p-2 h-10 text-sm leading-6 font-semibold bg-rose-700 text-white whitespace-nowrap text-center my-5">
                    고객리스트 가기
                  </Link>


                  <Link to={ALL_STORE_LIST_MANAGEMENT_PAGE}
                        className="w-48 gap-x-3 rounded-md p-2 h-10 text-sm leading-6 font-semibold bg-orange-600 text-white whitespace-nowrap text-center my-5">
                    지점리스트 가기
                  </Link>

                  <button
                      className="w-48 gap-x-3 rounded-md p-2 h-10 text-sm leading-6 font-semibold bg-emerald-600 text-white whitespace-nowrap text-center my-5">
                    뱅커 권한부여
                  </button>

                  <button
                      className="w-48 gap-x-3 rounded-md p-2 h-10 text-sm leading-6 font-semibold bg-violet-900 text-white whitespace-nowrap text-center my-5">
                    추천인 권한부여
                  </button>
                </div>
              </div>
          }
        </main>
      </div>
  )
}
export default ManageSupportPage;